import { useContext } from 'react';

import { DrawerContext } from './DrawerProvider';

export const useDrawer = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error('Component must be wrapped in DrawerProvider');
  }
  return context;
};
